"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIFormEditorComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("../form-parts/events");
const FIELD_TYPES = ['input', 'textarea', 'select', 'radio', 'checkbox', 'date', 'switch', 'slider'];
const FIELD_TYPE_OPTIONS = FIELD_TYPES.map((value) => ({
    label: `tutorial.form.editor.fieldType.${value}`,
    value
}));
const INPUT_FIELD_TYPES = ['text', 'number', 'email', 'password', 'tel', 'url', 'search', 'date', 'datetime-local', 'time'];
const INPUT_FIELD_TYPE_OPTIONS = INPUT_FIELD_TYPES.map((value) => ({
    label: `tutorial.form.editor.inputFieldType.${value}`,
    value
}));
//@ts-ignore                
let rwsTemplate = T.html `<div class="ai-form-editor">
  <div class="ai-form-editor-section">
    <part-input
      name="submitLabel"
      label="${() => 'tutorial.form.editor.submitLabel'.t()}"
      type="text"
      :value="${x => x.submitLabel}"
    ></part-input>
  </div>

  <div class="ai-form-editor-fields">
    ${(0, fast_element_1.repeat)(x => x.fields, (0, fast_element_1.html) `
      <div class="ai-form-editor-field">
        <div class="ai-form-editor-field-header" @click="${(x, c) => c.parent.toggleFieldExpanded(x.name)}">
          <span class="ai-form-editor-field-title">${x => x.label}</span>
          <span class="ai-form-editor-field-type">${(x, c) => c.parent.getFieldTypeLabel(x.type).t()}</span>
          <span class="ai-form-editor-field-toggle">${(x, c) => c.parent.isFieldExpanded(x.name) ? '−' : '+'}</span>
        </div>

        <div class="ai-form-editor-field-body ${(x, c) => c.parent.isFieldExpanded(x.name) ? '' : 'collapsed'}">
            <div class="ai-form-editor-row">
              <part-select
                name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-type`}"
                label="${() => 'tutorial.form.editor.type'.t()}"
                :options="${(x, c) => c.parent.getFieldTypeOptions()}"
                :value="${x => x.type}"
              ></part-select>
              <part-input
                name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-name`}"
                label="${() => 'tutorial.form.editor.name'.t()}"
                type="text"
                :value="${x => x.name}"
              ></part-input>
            </div>

            <part-input
              name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-label`}"
              label="${() => 'tutorial.form.editor.label'.t()}"
              type="text"
              :value="${x => x.label}"
            ></part-input>

            <part-switch
              name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-required`}"
              label="${() => 'tutorial.form.editor.required'.t()}"
              :checked="${x => x.required === 'true'}"
            ></part-switch>

            ${(0, fast_element_1.when)(x => x.type === 'input' || x.type === 'textarea' || x.type === 'date', (0, fast_element_1.html) `
              <part-input
                name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-placeholder`}"
                label="${() => 'tutorial.form.editor.placeholder'.t()}"
                type="text"
                :value="${x => x.placeholder || ''}"
              ></part-input>
            `)}

            ${(0, fast_element_1.when)(x => x.type === 'input', (0, fast_element_1.html) `
              <part-select
                name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-fieldType`}"
                label="${() => 'tutorial.form.editor.fieldType'.t()}"
                :options="${(x, c) => c.parent.getInputFieldTypeOptions()}"
                :value="${x => x.fieldType || 'text'}"
              ></part-select>
            `)}

            ${(0, fast_element_1.when)(x => x.type === 'textarea', (0, fast_element_1.html) `
              <part-input
                name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-rows`}"
                label="${() => 'tutorial.form.editor.rows'.t()}"
                type="text"
                :value="${x => x.rows || '3'}"
              ></part-input>
            `)}

            ${(0, fast_element_1.when)(x => x.type === 'date', (0, fast_element_1.html) `
              <div class="ai-form-editor-row">
                <part-input
                  name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-min`}"
                  label="${() => 'tutorial.form.editor.min'.t()}"
                  type="text"
                  :value="${x => x.min || ''}"
                ></part-input>
                <part-input
                  name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-max`}"
                  label="${() => 'tutorial.form.editor.max'.t()}"
                  type="text"
                  :value="${x => x.max || ''}"
                ></part-input>
              </div>
            `)}

            ${(0, fast_element_1.when)((x, c) => c.parent.hasOptions(x.type), (0, fast_element_1.html) `
              <div class="ai-form-editor-options">
                <div class="ai-form-editor-options-header">
                  <span class="ai-form-editor-label">${() => 'tutorial.form.editor.options'.t()}</span>
                  <button type="button" class="btn btn-sm" @click="${(x, c) => c.parent.addOption(c.parent.getFieldIndex(x))}">${() => 'tutorial.form.editor.addOption'.t()}</button>
                </div>
                ${(0, fast_element_1.repeat)(x => x.options || [], (0, fast_element_1.html) `
                  <div class="ai-form-editor-option">
                    <part-input
                      name="${(option, c) => `field-${c.parentContext.parent.getFieldIndex(c.parent)}-option-${c.parentContext.parent.getOptionIndex(c.parent, option)}-label`}"
                      label="${() => 'tutorial.form.editor.optionLabel'.t()}"
                      type="text"
                      :value="${x => x.label}"
                    ></part-input>
                    <part-input
                      name="${(option, c) => `field-${c.parentContext.parent.getFieldIndex(c.parent)}-option-${c.parentContext.parent.getOptionIndex(c.parent, option)}-value`}"
                      label="${() => 'tutorial.form.editor.optionValue'.t()}"
                      type="text"
                      :value="${x => x.value}"
                    ></part-input>
                    <button type="button" class="btn btn-danger btn-sm" @click="${(option, c) => c.parentContext.parent.removeOption(c.parentContext.parent.getFieldIndex(c.parent), c.parentContext.parent.getOptionIndex(c.parent, option))}">${() => 'tutorial.form.editor.remove'.t()}</button>
                  </div>
                `)}
              </div>
              <part-switch
                name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-multiple`}"
                label="${() => 'tutorial.form.editor.multiple'.t()}"
                :checked="${x => x.multiple}"
              ></part-switch>
            `)}

            ${(0, fast_element_1.when)(x => x.type === 'slider', (0, fast_element_1.html) `
              <div class="ai-form-editor-row">
                <part-input
                  name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-min`}"
                  label="${() => 'tutorial.form.editor.min'.t()}"
                  type="text"
                  :value="${x => x.min || '0'}"
                ></part-input>
                <part-input
                  name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-max`}"
                  label="${() => 'tutorial.form.editor.max'.t()}"
                  type="text"
                  :value="${x => x.max || '100'}"
                ></part-input>
                <part-input
                  name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-step`}"
                  label="${() => 'tutorial.form.editor.step'.t()}"
                  type="text"
                  :value="${x => x.step || '1'}"
                ></part-input>
                <part-input
                  name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-unit`}"
                  label="${() => 'tutorial.form.editor.unit'.t()}"
                  type="text"
                  :value="${x => x.unit || ''}"
                ></part-input>
              </div>
              <part-switch
                name="${(x, c) => `field-${c.parent.getFieldIndex(x)}-showValue`}"
                label="${() => 'tutorial.form.editor.showValue'.t()}"
                :checked="${x => x.showValue === 'true'}"
              ></part-switch>
            `)}

            <div class="ai-form-editor-field-actions">
              <button type="button" class="btn btn-sm" ?disabled="${(x, c) => c.parent.getFieldIndex(x) === 0}" @click="${(x, c) => c.parent.moveField(c.parent.getFieldIndex(x), 'up')}">${() => 'tutorial.form.editor.moveUp'.t()}</button>
              <button type="button" class="btn btn-sm" ?disabled="${(x, c) => c.parent.getFieldIndex(x) === c.parent.fields.length - 1}" @click="${(x, c) => c.parent.moveField(c.parent.getFieldIndex(x), 'down')}">${() => 'tutorial.form.editor.moveDown'.t()}</button>
              <button type="button" class="btn btn-danger btn-sm" @click="${(x, c) => c.parent.removeField(c.parent.getFieldIndex(x))}">${() => 'tutorial.form.editor.remove'.t()}</button>
            </div>
        </div>
      </div>
    `)}
  </div>

  <div class="ai-form-editor-actions">
    <button type="button" class="btn btn-primary" @click="${x => x.addField()}">${() => 'tutorial.form.editor.addField'.t()}</button>
    <button type="button" class="btn btn-success" @click="${x => x.saveForm()}">${() => 'tutorial.form.editor.saveForm'.t()}</button>
  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.ai-form-editor {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid var(--brand-border);
  border-radius: 14px;
  background: #fff;
  font-family: "Segoe UI", system-ui, -apple-system, "Helvetica Neue", Arial, sans-serif;
}
.ai-form-editor .ai-form-editor-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.ai-form-editor .ai-form-editor-label {
  font-weight: 500;
  color: var(--ink);
}
.ai-form-editor .ai-form-editor-fields {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.ai-form-editor .ai-form-editor-field {
  border: 1px solid var(--brand-border);
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}
.ai-form-editor .ai-form-editor-field-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  background: #fafbfc;
  user-select: none;
}
.ai-form-editor .ai-form-editor-field-header:hover {
  background: var(--brand-soft);
}
.ai-form-editor part-input::part(input),
.ai-form-editor part-select::part(select),
.ai-form-editor part-switch::part(input) {
  border: 1px solid var(--brand-border) !important;
  border-radius: 8px !important;
  color: var(--ink) !important;
  font-size: 0.95rem !important;
  background: #fff !important;
  box-shadow: none !important;
  padding: 0.55rem 0.75rem !important;
}
.ai-form-editor part-input::part(input):focus,
.ai-form-editor part-select::part(select):focus {
  border-color: var(--brand) !important;
  box-shadow: 0 0 0 0.2rem rgba(23, 180, 166, 0.2) !important;
  outline: none !important;
}
.ai-form-editor part-input::part(label),
.ai-form-editor part-select::part(label),
.ai-form-editor part-switch::part(label) {
  color: var(--muted) !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
}
.ai-form-editor .ai-form-editor-field-title {
  flex: 1;
  font-weight: 600;
  color: var(--ink);
}
.ai-form-editor .ai-form-editor-field-type {
  font-size: 0.75rem;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.ai-form-editor .ai-form-editor-field-toggle {
  font-weight: bold;
  color: var(--brand);
}
.ai-form-editor .ai-form-editor-field-body {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.ai-form-editor .ai-form-editor-field-body.collapsed {
  display: none;
}
.ai-form-editor .ai-form-editor-row {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}
.ai-form-editor .ai-form-editor-row > * {
  flex: 1;
  min-width: 0;
}
.ai-form-editor .ai-form-editor-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
  background: var(--bg);
  border-radius: 8px;
}
.ai-form-editor .ai-form-editor-options-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ai-form-editor .ai-form-editor-option {
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
}
.ai-form-editor .ai-form-editor-option > * {
  flex: 1;
  min-width: 0;
}
.ai-form-editor .ai-form-editor-field-actions,
.ai-form-editor .ai-form-editor-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.ai-form-editor .btn {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
}
.ai-form-editor .btn.btn-primary {
  background: var(--action);
  color: #fff;
  border-color: var(--action);
}
.ai-form-editor .btn.btn-primary:hover {
  background: var(--action-dark);
  border-color: var(--action-dark);
}
.ai-form-editor .btn.btn-success {
  background: var(--brand);
  color: #fff;
  border-color: var(--brand);
}
.ai-form-editor .btn.btn-success:hover {
  background: var(--brand-dark);
  border-color: var(--brand-dark);
}
.ai-form-editor .btn.btn-danger {
  background: var(--wf-red);
  color: #fff;
  border-color: var(--wf-red);
}
.ai-form-editor .btn.btn-danger:hover {
  background: #c53030;
  border-color: #c53030;
}
.ai-form-editor .btn.btn-sm {
  height: 34px;
  padding: 0 10px;
  font-size: 0.82rem;
}
.ai-form-editor .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`;
const shadowOptions = { "mode": "open" };
let AIFormEditorComponent = class AIFormEditorComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.data = {};
        this.expandedFields = {};
    }
    connectedCallback() {
        super.connectedCallback();
        this.on(events_1.inputEvents.changed, (event) => {
            this.handleInputChanged(event.detail);
        });
        this.ensureData();
    }
    get fields() {
        return this.data.fields || [];
    }
    get submitLabel() {
        return this.data.submitLabel || 'tutorial.form.editor.defaultSubmitLabel'.t();
    }
    getFieldTypeOptions() {
        return FIELD_TYPE_OPTIONS.map((opt) => ({
            ...opt,
            label: `tutorial.form.editor.fieldType.${opt.value}`
        }));
    }
    getInputFieldTypeOptions() {
        return INPUT_FIELD_TYPE_OPTIONS.map((opt) => ({
            ...opt,
            label: `tutorial.form.editor.inputFieldType.${opt.value}`
        }));
    }
    getFieldTypeLabel(type) {
        const option = FIELD_TYPE_OPTIONS.find((opt) => opt.value === type);
        return option ? `tutorial.form.editor.fieldType.${option.value}` : type;
    }
    hasOptions(type) {
        return type === 'select' || type === 'radio' || type === 'checkbox';
    }
    getFieldIndex(field) {
        return this.fields.findIndex((f) => f === field);
    }
    getOptionIndex(field, option) {
        return (field.options || []).findIndex((o) => o === option);
    }
    isFieldExpanded(name) {
        return !!this.expandedFields[name];
    }
    toggleFieldExpanded(name) {
        this.expandedFields = { ...this.expandedFields, [name]: !this.expandedFields[name] };
    }
    addField() {
        this.ensureData();
        const timestamp = Date.now();
        const newField = {
            type: 'input',
            name: `field_${timestamp}`,
            label: 'tutorial.form.editor.defaultFieldLabel'.t(),
            required: 'false'
        };
        this.data = { ...this.data, fields: [...this.data.fields, newField] };
        this.expandedFields = { ...this.expandedFields, [newField.name]: true };
        this.emitChange();
    }
    removeField(index) {
        this.ensureData();
        const field = this.data.fields[index];
        if (field) {
            const { [field.name]: _, ...rest } = this.expandedFields;
            this.expandedFields = rest;
        }
        this.data = {
            ...this.data,
            fields: this.data.fields.filter((_, i) => i !== index)
        };
        this.emitChange();
    }
    moveField(index, direction) {
        this.ensureData();
        const newIndex = direction === 'up' ? index - 1 : index + 1;
        if (newIndex < 0 || newIndex >= this.data.fields.length) {
            return;
        }
        const fields = [...this.data.fields];
        [fields[index], fields[newIndex]] = [fields[newIndex], fields[index]];
        this.data = { ...this.data, fields };
        this.emitChange();
    }
    updateField(index, updates) {
        this.ensureData();
        this.data = {
            ...this.data,
            fields: this.data.fields.map((field, i) => i === index ? { ...field, ...updates } : field)
        };
        this.emitChange();
    }
    addOption(fieldIndex) {
        const field = this.data.fields[fieldIndex];
        if (!field) {
            return;
        }
        const options = [...(field.options || [])];
        options.push({
            label: 'tutorial.form.editor.defaultOptionLabel'.t({ index: options.length + 1 }),
            value: `option_${options.length + 1}`
        });
        this.updateField(fieldIndex, { options });
    }
    removeOption(fieldIndex, optionIndex) {
        const field = this.data.fields[fieldIndex];
        if (!field || !field.options) {
            return;
        }
        this.updateField(fieldIndex, {
            options: field.options.filter((_, i) => i !== optionIndex)
        });
    }
    updateOption(fieldIndex, optionIndex, updates) {
        const field = this.data.fields[fieldIndex];
        if (!field || !field.options) {
            return;
        }
        this.updateField(fieldIndex, {
            options: field.options.map((option, i) => i === optionIndex ? { ...option, ...updates } : option)
        });
    }
    updateSubmitLabel(value) {
        this.ensureData();
        this.data = { ...this.data, submitLabel: value };
        this.emitChange();
    }
    saveForm() {
        this.ensureData();
        this.dispatchEvent(new CustomEvent('ai-form-editor:save', {
            detail: { ...this.data },
            bubbles: true,
            composed: true
        }));
    }
    handleInputChanged(detail) {
        var _a;
        const { fieldName, value } = detail;
        if (fieldName === 'submitLabel') {
            this.updateSubmitLabel(String(value !== null && value !== void 0 ? value : ''));
            return;
        }
        const match = fieldName.match(/^field-(\d+)-(.+)$/);
        if (!match) {
            return;
        }
        const index = parseInt(match[1], 10);
        const property = match[2];
        if (property === 'type') {
            this.updateField(index, { type: String(value) });
        }
        else if (property === 'name') {
            const oldName = (_a = this.data.fields[index]) === null || _a === void 0 ? void 0 : _a.name;
            const newName = String(value);
            if (oldName !== undefined && oldName !== newName && this.expandedFields[oldName]) {
                const { [oldName]: _, ...rest } = this.expandedFields;
                this.expandedFields = { ...rest, [newName]: true };
            }
            this.updateField(index, { name: newName });
        }
        else if (property === 'label') {
            this.updateField(index, { label: String(value) });
        }
        else if (property === 'required') {
            const boolValue = typeof value === 'boolean' ? value : String(value) === 'true';
            this.updateField(index, { required: boolValue ? 'true' : 'false' });
        }
        else if (property === 'placeholder') {
            this.updateField(index, { placeholder: String(value !== null && value !== void 0 ? value : '') });
        }
        else if (property === 'fieldType') {
            this.updateField(index, { fieldType: String(value !== null && value !== void 0 ? value : '') });
        }
        else if (property === 'rows') {
            this.updateField(index, { rows: String(value !== null && value !== void 0 ? value : '') });
        }
        else if (property === 'min') {
            this.updateField(index, { min: String(value !== null && value !== void 0 ? value : '') });
        }
        else if (property === 'max') {
            this.updateField(index, { max: String(value !== null && value !== void 0 ? value : '') });
        }
        else if (property === 'multiple') {
            const boolValue = typeof value === 'boolean' ? value : String(value) === 'true';
            this.updateField(index, { multiple: boolValue });
        }
        else if (property === 'step') {
            this.updateField(index, { step: String(value !== null && value !== void 0 ? value : '') });
        }
        else if (property === 'unit') {
            this.updateField(index, { unit: String(value !== null && value !== void 0 ? value : '') });
        }
        else if (property === 'showValue') {
            const boolValue = typeof value === 'boolean' ? value : String(value) === 'true';
            this.updateField(index, { showValue: boolValue ? 'true' : 'false' });
        }
        else {
            const optionMatch = property.match(/^option-(\d+)-(label|value)$/);
            if (optionMatch) {
                const optionIndex = parseInt(optionMatch[1], 10);
                const optionProperty = optionMatch[2];
                this.updateOption(index, optionIndex, { [optionProperty]: String(value !== null && value !== void 0 ? value : '') });
            }
        }
    }
    ensureData() {
        if (!this.data) {
            this.data = {};
        }
        if (!Array.isArray(this.data.fields)) {
            this.data = { ...this.data, fields: [] };
        }
    }
    emitChange() {
        this.ensureData();
        this.dispatchEvent(new CustomEvent('ai-form-editor:changed', {
            detail: { ...this.data },
            bubbles: true,
            composed: true
        }));
    }
};
exports.AIFormEditorComponent = AIFormEditorComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AIFormEditorComponent.prototype, "data", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], AIFormEditorComponent.prototype, "expandedFields", void 0);
exports.AIFormEditorComponent = AIFormEditorComponent = __decorate([
    (0, client_1.RWSView)('ai-form-editor', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], AIFormEditorComponent);
AIFormEditorComponent.defineComponent();
